import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

function SummaryItem({title,items,icon,subItems,subTitle,layout = 'default'}) {
    const isRowsLayout = layout === 'rows';

    return (
        <div className='first:border-t-0 border-t border-gray-200 p-2 summary-item print-avoid-break'>
            <div className={isRowsLayout ? 'flex items-start justify-between gap-6' : 'flex items-center justify-between'}>
                <div className={isRowsLayout ? 'flex items-center justify-start gap-2 pt-1 shrink-0' : 'flex items-center justify-start gap-2'}>
                    <FontAwesomeIcon className='text-sm' icon={icon} />
                    <h3 className='text-sm' >{title}</h3>
                </div>
                <div className={isRowsLayout ? 'flex min-w-[220px] flex-col gap-3' : 'flex gap-2'}>
                    {items.map(({name,value}, index) => (
                        <div className={isRowsLayout ? 'flex items-center justify-between gap-6 border-b border-gray-100 pb-2 last:border-b-0 last:pb-0' : 'flex flex-col items-center gap-4'} key={index}>
                            {value && <h5 className={isRowsLayout ? 'text-gray-300 text-sm capitalize' : 'text-gray-300 text-sm capitalize'}>{name}</h5>}
                            <p className={isRowsLayout ? 'text-sm capitalize whitespace-nowrap text-right' : 'text-sm capitalize'}>{value}</p>
                        </div>
                    ))}
                </div>
            </div>
            {subItems && (
                <div className='flex items-center justify-between'>
                    <div className='flex items-center justify-start gap-2'>
                        <FontAwesomeIcon className='text-sm' icon={icon} />
                        <h3 className='text-sm' >{subTitle || title}</h3>
                    </div>
                    <div className='flex gap-2'>
                        {subItems.map(({name,value}, index) => (
                            <div className='flex flex-col items-center gap-4' key={index}>
                                {value && <h5 className='text-gray-300 text-sm capitalize'>{name}</h5>}
                                <p className='text-sm capitalize'>{value}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

export default SummaryItem;
